import { formatCurrencyNoDecimals } from '@if/core/utils'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useCreditApplicationData } from '@src/contexts/CreditApplicationContext'
import { useTranslation } from 'react-i18next'
import ClickableAddress from '../../../components/AddressWithGoogleSearch'
import { useCurrentLang, useJobTypeEnum } from '../../../data/selectors/app-config-selectors'
import { ApplicantJob } from '../../../data/types'
import Row from './creditReportComponents/tableRow'

interface Props {
  previousJobs: ApplicantJob[]
}

const PreviousJobs = ({ previousJobs }: Props) => {
  const { t } = useTranslation()
  const { creditApplication } = useCreditApplicationData()
  const financingProgramId = creditApplication?.financingProgramId
  const jobTypeEnum = useJobTypeEnum(financingProgramId || null)
  const lang = useCurrentLang()

  return (
    <Row id="previousJobs" name={t('editCreditApplication.income.previousJob.label')}>
      {previousJobs && previousJobs.length > 0 ? (
        <TableContainer>
          <Table sx={{ display: 'contents' }} aria-label="previous jobs table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography textAlign="left" variant="h6" component="h6">
                    {t('editCreditApplication.income.job.employerName')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography textAlign="left" variant="h6" component="h6">
                    {t('credit.address')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography textAlign="left" variant="h6" component="h6">
                    {t('worksheetCommon.duration')}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography textAlign="right" variant="h6" component="h6">
                    {t('editCreditApplication.income.job.annualSalary')}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {previousJobs.map((item, index) => (
                <TableRow key={`${item.employerName}-${index}`}>
                  <TableCell>
                    <Typography>{`${item.employerName}${
                      jobTypeEnum?.[item.jobType.toString()]?.[lang]
                        ? ` (${jobTypeEnum[item.jobType.toString()][lang]})`
                        : ''
                    } : ${item.jobTitle}`}</Typography>
                  </TableCell>
                  <TableCell>
                    <ClickableAddress address={item.address} />
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {item.years || item.months
                        ? `${item.years || 0} ${String(t('editCreditApplication.address.since.years')).toLowerCase()} ${item.months || 0} ${String(t('editCreditApplication.address.since.months'))}`
                        : 'N/A'}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">{formatCurrencyNoDecimals(item.annualSalary)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div style={{ padding: '16px', textAlign: 'center', fontStyle: 'italic', color: '#666' }}>
          {t('editCreditApplication.income.previousJob.noJobsFound', 'No previous jobs found')}
        </div>
      )}
    </Row>
  )
}

export default PreviousJobs